import { Scrollbars } from "react-custom-scrollbars-2";
import { NavLink, Routes, Route, Navigate, useLocation } from "react-router-dom";
import SearchResultsView from "./SearchResultsView";
import FeaturedCatalogContainer from "../../FeaturedCatalog";
import CatalogCategoriesContainer from "../../CategoriesContainer";
import CachedImage from "../../../../components/common/CachedImage";
import { isUserOnline } from "../../../../services/storage/LocalStorage";


// const isFeatured = (location) =>
// 	location.pathname === "/app/catalog" || location.pathname === "/app/catalog/featured";

// const isCategory = (location) =>
// 	location.pathname === "/app/catalog/categories" ||
// 	location.pathname.indexOf("/app/catalog/categories/") !== -1;


const CatalogMain = (props) => {
	const location = useLocation();
	const { searchResults, searchKey } = props;


	if (!isUserOnline()) {
		return (
			<div
				className="Catalog-chatarea catalog-left"
				style={{
					background: "url('/img/welcomescreen-background.png')",
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			>
				<div
					className="absolute inset-0 flex flex-col items-center justify-center text-center"
				>
					<CachedImage
						image={"/img/sad-cloud.png"}
						imgKey="sad-cloud-offline"
						className="w-[65px] h-[50px]"
						alt="offline"
					/>
					<p className="font-semibold mt-3 mb-0">Apps are not available offline.</p>
					<p>Please connect and try again.</p>
				</div>

			</div>
		);
	};

	return (
		<div className="Catalog-chatarea catalog-left">
			<div className="sidebar-body flex" id="app-body">
				{searchKey ? (
					<SearchResultsView
						bots={searchResults}
						searchKey={searchKey}
					/>
				) : (
					<div className="flex flex-col w-full">
						<div className="items-center h-[45px] bg-[#00A7D6]">
							<div
								className="Catalog-tabs flex justify-center items-center"
								style={{
									height: "100%",
									padding: "0 50px",
								}}
							>
								<NavLink
									className="catalog-link"
									to="/app/catalog/featured"
									// isActive={() => isFeatured(location)}
								>
									<div className={`flex flex-col items-center`}>
										<div>Featured</div>
										<div className="oval" />
									</div>
								</NavLink>

								<NavLink
									className="catalog-link"
									to="/app/catalog/categories"
									// isActive={() => isCategory(location)}
								>
									<div className={`flex flex-col items-center`}>
										<div>Categories</div>
										<div className="oval" />
									</div>
								</NavLink>
							</div>
						</div>

						<Scrollbars autoHide style={{ height: "84vh", width: "100%" }}>
							<div className="p-3 mt-auto">
								<Routes>
									<Route index element={<Navigate to="featured" replace />} />
									<Route path="featured" element={<FeaturedCatalogContainer {...props} />} />
									<Route path="categories" element={<CatalogCategoriesContainer {...props} />} />
									<Route path="categories/:id" element={<CatalogCategoriesContainer {...props} />} />
									<Route path="updates" element={<div>Updates</div>} />
								</Routes>
							</div>
						</Scrollbars>
					</div>
				)}
			</div>
		</div>
	);
};

export default CatalogMain;
